export default {"src":"/_next/static/media/XEL.d6a46bb3.svg","height":18,"width":18};